import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import { connect } from "react-redux";


const Header = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const signInUrl = process.env.REACT_APP_LOGIN_URL || '/customer/login';

    useEffect(() => {
        let lastScrollPosition = 0;

        const handleScroll = () => {
            const header = document.getElementById("header");
            const currentScrollPosition = window.scrollY;
            const scrollDirection =
                currentScrollPosition < lastScrollPosition ? "up" : "down";

            if (header) {
                if (currentScrollPosition > 100) {
                    if (scrollDirection === "up") {
                        header.classList.add("header-fixed");
                    } else {
                        header.classList.remove("header-fixed");
                    }
                } else {
                    header.classList.remove("header-fixed");
                }
            }

            lastScrollPosition = currentScrollPosition;
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <header id="header">
            <div className={"" + props.hclass}>
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-xl-3 col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenu />
                            </div>
                            <div className="col-xl-2 col-lg-2 col-md-6 col-5">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/">
                                        <img src={props.Logo} alt="" />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-xl-7 col-lg-7 col-md-1 col-1 d-none d-lg-block">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder justify-content-center">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/">Home</Link>
                                        </li>
                                        <li className="">
                                            <Link onClick={ClickHandler} to="/about">About</Link>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="#">Our Services</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/services">services </Link></li>
                                                <li><Link onClick={ClickHandler} to="/services/air-freight">Air Freight</Link></li>
                                                <li><Link onClick={ClickHandler} to="/services/sea-freight">Sea Freight</Link></li>
                                                <li><Link onClick={ClickHandler} to="/services/road-freight">Road Freight</Link></li>
                                                <li><Link onClick={ClickHandler} to="/services/management">Warehouse Management</Link></li>
                                                <li><Link onClick={ClickHandler} to="/services/customs-clearance">Customs Clearance</Link></li>
                                                <li><Link onClick={ClickHandler} to="/services/project-logistics">Project Logistics</Link></li>
                                                <li><Link onClick={ClickHandler} to="/services/heavy-lifts">Heavy Lifts</Link></li>
                                                <li><Link onClick={ClickHandler} to="/services/cargo-insurance">Cargo Insurance</Link></li>
                                                <li><Link onClick={ClickHandler} to="/services/removals-relocation">Removals Relocation</Link></li>
                                            </ul>
                                        </li>
                                        {/* <li className="">
                                            <Link onClick={ClickHandler} to="/blog">blog</Link>
                                        </li> */}
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/project">Our Project</Link>
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/contact">Contact</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-3 col-md-3 col-4">
                                <div className="header-right 1">
                                    <div className="close-form">
                                        <a
                                            href={signInUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="theme-btn sign-in"
                                        >
                                            <span>Sign In</span>
                                            <i className="fas fa-sign-in-alt"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};

export default connect(mapStateToProps)(Header);
